'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import leaveSetAction from '../../actions/leaveSetAction';

class EmpCard extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    
    handleClick(e){
        leaveSetAction.staffId(this.props.staff.staffId);
        leaveSetAction.userName(this.props.staff.userName);
        leaveSetAction.updating(true);
    }

    render() {
        return (
            <div className="atd-card" onClick={this.handleClick}>
                <div className="atd-img-wp">
                    <img className="atd-img" src={this.props.staff.userImage} />
                </div>
                <div className="atd-nm">{this.props.staff.userName}</div>
            </div>
        );
    }
}
export default EmpCard;


// WEBPACK FOOTER //
// ./app/setComponents/leaveSetComponents/empCard.js